import React from 'react'
import ListaHistorico from './components/ListaHistorico'
function componentRelEspelho(comp, dados) {
    return ""
}


function component(item, props) {
    return (<ListaHistorico customForm={props.customForm} uidObj={props.atualValues ? props.atualValues.uid : ""} fieldHistorico={item.fieldHistorico} />)
}

const modelo = {
    label: "Histórico",
    typeComponente: "HistoricoField",
    fieldHistorico: "titulo"
}

const comp = {
    typeComponente: "HistoricoField",
    configView: {
        nome: "Historico Field",
        modelo

    },
    componentRelEspelho,
    component
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/HistoricoField/index.js